import { render, staticRenderFns } from "./cur_title.vue?vue&type=template&id=2532d4ec&scoped=true&"
import script from "./cur_title.vue?vue&type=script&lang=js&"
export * from "./cur_title.vue?vue&type=script&lang=js&"
import style0 from "./cur_title.vue?vue&type=style&index=0&id=2532d4ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2532d4ec",
  null
  
)

export default component.exports